import * as Sentry from "@sentry/react";

declare global {
  interface Window {
    __CSP_VIOLATION_SENTRY_LISTENER__?: boolean;
  }
}

const logToSentry = (event: SecurityPolicyViolationEvent) => {
  Sentry.withScope((scope) => {
    scope.setLevel("warning");
    scope.setTag("telemetry", "csp-violation");
    scope.setTag("csp.disposition", event.disposition || "unknown");
    scope.setTag(
      "csp.effectiveDirective",
      event.effectiveDirective || "unknown"
    );
    scope.setContext("csp", {
      blockedURI: event.blockedURI,
      documentURI: event.documentURI,
      disposition: event.disposition,
      effectiveDirective: event.effectiveDirective,
      originalPolicy: event.originalPolicy,
      referrer: event.referrer,
      sourceFile: event.sourceFile,
      violatedDirective: event.violatedDirective,
      statusCode: event.statusCode
    });
    Sentry.captureMessage("Content Security Policy violation");
  });
};

export const initSentryCSPViolationListener = () => {
  if (window.__CSP_VIOLATION_SENTRY_LISTENER__) {
    return;
  }

  const handleCSPViolation = (event: SecurityPolicyViolationEvent) => {
    logToSentry(event);
  };

  window.addEventListener("securitypolicyviolation", handleCSPViolation);

  window.__CSP_VIOLATION_SENTRY_LISTENER__ = true;
};
